export default "__VITE_ASSET__ByXNkzWL__"